import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Client } from "../../clients/_types/client";

export class CaseState extends Resource {
    public override type = 'caseStates';

    @prop()
    public code!: string;
    
    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public backgroundColor!: string;

    @prop()
    @required()
    public foregroundColor!: string;

    @prop()
    public isInitial: boolean = false;

    @prop()
    public isFinal: boolean = false;

    @prop()
    public isSystem: boolean = false;

    @prop()
    public configuration?: string;

    @prop()
    public notUpdateWhenCaseServiceConfirmed: boolean = false;

    @prop()
    public enableForSinister: boolean = true;

    @prop()
    public enableForSeriousSinister: boolean = false;

    @prop()
    public enableForAssets: boolean = false;

}